import { KDDI_IOT_TOILET_PLACE_URL, } from "app/env"

export function createRestroomPageUrl (placementId: string) {
  return `${KDDI_IOT_TOILET_PLACE_URL}/${placementId}`
}
